import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/photos/20220713_holloway-566.jpg");
